import { Injectable } from "@angular/core";

export type PageActionButtonPath = [navTabNumber: number, pageNumber: number, pageActionButtonCode: string];

@Injectable({
  providedIn: 'root'
})
export class HtmlHelperService {

  ensurePageActionButtonsAreEnabled(pageActionButtonPaths: PageActionButtonPath[]): void {
    const pageActionButtonIds = pageActionButtonPaths
      .map(pageActionButtonPath => {
        const [navTabNumber, pageNumber, pageActionButtonCode] = pageActionButtonPath;
        return this.getPageActionButtonId(pageNumber, pageActionButtonCode);
      });
    const distinctPageActionButtonIds = [...new Set(pageActionButtonIds)];
    for (const pageActionButtonId of distinctPageActionButtonIds) {
      const htmlButtonElements = this.getElementsById<HTMLButtonElement>(pageActionButtonId);
      for (const htmlButtonElement of htmlButtonElements ?? []) {
        htmlButtonElement?.removeAttribute('disabled');
      }
    }
  }

  getElementsById<TElement extends Element>(id: string): TElement[] {
    const elements = Array.from<TElement>(document.querySelectorAll(`#${id}`));
    return elements;
  }

  getPageActionButtonId(pageNumber: number, pageActionButtonCode: string): string {
    const pageActionButtonId = `page${pageNumber}-${pageActionButtonCode}`;
    return pageActionButtonId;
  }

  setFocusToHtmlElementById(id: string, delayMs = 0): void {
    this.setFocusToHtmlElement(() => document.getElementById(id), delayMs);
  }

  setFocusToHtmlElement(getHtmlElement: () => HTMLElement, delayMs = 0): void {
    const functionToInvoke = () => {
      const element = getHtmlElement();
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.focus({ preventScroll: true });
      }
    };
    this.invokeFunction(() => functionToInvoke(), delayMs);
  }

  private invokeFunction(functionToInvoke: () => void, delayMs: number = null): void {
    if (delayMs !== null && delayMs !== undefined && delayMs >= 0) {
      setTimeout(() => functionToInvoke(), delayMs);
    } else {
      functionToInvoke();
    }
  }
}
